import { useEffect, useRef, useState } from "react";
import type { ReactNode } from "react";

interface RevealProps {
  children: ReactNode;
  className?: string;
  Delay?: number;
}

export function Reveal({ children, className = "", Delay = 0 }: RevealProps) {
  const ElementRef = useRef<HTMLDivElement>(null);
  const [IsVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const Node = ElementRef.current;
    if (!Node) return;
    const Observer = new IntersectionObserver(
      (pEntries) => {
        pEntries.forEach((pEntry) => {
          if (pEntry.isIntersecting) {
            setIsVisible(true);
            Observer.disconnect();
          }
        });
      },
      { threshold: 0.12 },
    );
    Observer.observe(Node);
    return () => Observer.disconnect();
  }, []);

  return (
    <div
      ref={ElementRef}
      className={`reveal ${IsVisible ? "reveal-visible" : ""} ${className}`}
      style={Delay ? { transitionDelay: `${Delay}ms` } : undefined}
    >
      {children}
    </div>
  );
}
